import styled from 'styled-components';

export const MpParagraph = styled(`p`)`
	white-space: pre-wrap;
	font-weight: 400;
	font-size: 16px;
	line-height: 24px;

	@media (max-width: 575px) {
		font-size: 14px;
	}
`;
